// src/MANAGEMENT/BOARD/EDITORIAL/BLOG/EEdit.tsx

import React, { useState } from "react";

import { Description, Article } from "@mui/icons-material";
import AllPosts from "./POSTS/AllPosts";
import AllPages from "./PAGES/AllPages";

const EEdit: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"post" | "page">("post");

  return (
    <div style={styles.container}>
      {/* Tabs */}
      <div style={styles.tabs}>
        <div
          style={activeTab === "post" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("post")}
        >
          <Article style={styles.icon} />
          <span>Edit Posts</span>
        </div>
        <div
          style={activeTab === "page" ? styles.activeTab : styles.tab}
          onClick={() => setActiveTab("page")}
        >
          <Description style={styles.icon} />
          <span>Edit Pages</span>
        </div>
      </div>

      {/* Main Content */}
      <div style={styles.content}>
        {activeTab === "post" ? <AllPosts /> : <AllPages />}
      </div>
    </div>
  );
};

export default EEdit;

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    background: "linear-gradient(to bottom, #0a0014, #1e003a, #111)",
    color: "#fff",
    minHeight: "100vh",
    fontFamily: "sans-serif",
  },
  tabs: {
    display: "flex",
    justifyContent: "center",
    borderBottom: "1px solid #333",
    padding: "12px 0",
    backgroundColor: "#0f0f1a",
  },
  tab: {
    padding: "10px 20px",
    margin: "0 10px",
    cursor: "pointer",
    borderRadius: 6,
    color: "#bbb",
    display: "flex",
    alignItems: "center",
    gap: 8,
    transition: "0.2s",
  },
  activeTab: {
    padding: "10px 20px",
    margin: "0 10px",
    cursor: "pointer",
    borderRadius: 6,
    background: "linear-gradient(to right, #a78bfa, #c084fc)",
    color: "#000",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  icon: {
    fontSize: 20,
  },
  content: {
    padding: "2rem",
  },
};
